import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderFormScreen } from '@/features/purchasing-orders/order-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for editing a DRAFT purchase order (WP05). The API refuses an
 * edit on anything but a draft; the form says so and offers no save.
 */
export const Route = createFileRoute('/_authenticated/purchasing/orders/$orderId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'purchase_order.edit')) {
      throw redirect({ to: '/purchasing/orders/$orderId', params: { orderId: params.orderId } })
    }
  },
  component: PurchaseOrderEditRoute,
})

function PurchaseOrderEditRoute() {
  const { orderId } = Route.useParams()

  return <OrderFormScreen orderId={orderId} />
}
